// src/pages/Home.js
import React from 'react';

function Home() {
  return (
    <div>
      <h2>Welcome to the Documentation Site for Sage Common Data Models</h2>
      <p>Select a section from the sidebar to get started.</p>
    </div>
  );
}

export default Home;
